module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSpinner),
      expression: "loadingSpinner"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "Подождите"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-top": "0px"
    }
  }, [_vm._v("Медиа")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-5px",
      "padding-left": "5px",
      "float": "left"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "5px",
      "padding-top": "5px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.reloadOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-loop",
      "size": "18"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.commonData.isLoaded == false) ? _c('div', [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.dataIsLoaded == false) ? _c('div', [_vm._v("\n  Подождите, загружаются данные по банкам\n")]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "padding-right": "0px",
      "float": "left"
    },
    style: (_vm.expandTable == true ? 'width:100%' : 'width:calc(100% - 500px)')
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "padding-top": "11px",
      "padding-bottom": "0px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Фильтр")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "12px",
      "display": "inline-block",
      "width": "300px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.filterValueOnChange
    },
    model: {
      value: (_vm.filterValue),
      callback: function($$v) {
        _vm.filterValue = $$v
      },
      expression: "filterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float2": "right",
      "margin": "0 10px 0 7px",
      "display": "inline-block"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "height": "36px",
      "margin-bottom": "0px"
    },
    attrs: {
      "type": "ghost",
      "size": "large",
      "disabled": (_vm.editingDataRow != null) && (_vm.editingDataRow.val.id == null)
    },
    on: {
      "click": _vm.newEditingDataRowOnClick
    }
  }, [_vm._v("+")])], 1), _vm._v(" "), (_vm.filteredRecords.length > 0) ? _c('div', [_vm._l((_vm.filteredRecords), function(itemData, keyData) {
    return _c('div', {
      key: keyData,
      staticStyle: {
        "width": "300px",
        "height": "335px",
        "padding": "5px",
        "margin": "0 10px 10px 0",
        "border-radius": "10px",
        "float": "left"
      },
      style: ({
        border: _vm.isRowSelected(itemData) == true ? '2px solid #a0a7ff' : '2px solid #aaa',
        color: _vm.isRowSelected(itemData) == true ? '#fff' : '#fff',
        background: _vm.isRowSelected(itemData) === true ? '#a0a7ff' : '#a9acb7'
      }),
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(itemData)
        }
      }
    }, [_c('div', {
      staticClass: "list-image-thumb",
      style: ({
        'background-image': 'url(' + _vm.appSettings.server.host + _vm.appSettings.server.fileEntityGetFile + itemData.val.id + ')'
      })
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "margin": "10px 0 0px 0",
        "padding": "0px",
        "float": "left",
        "text-align": "center"
      }
    }, [_c('Icon', {
      staticStyle: {
        "font-size": "19px"
      },
      attrs: {
        "type": "image"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "18px",
        "margin-left": "10px"
      }
    }, [_c('b', [_vm._v(_vm._s(itemData.val.name) + " ")])])], 1)])
  }), _vm._v(" "), (_vm.filteredRecords.length == _vm.numOfItemsToShowWithEmptyFilter) ? _c('div', {
    staticStyle: {
      "clear": "left"
    }
  }, [_vm._v("\n     * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.\n   ")]) : _vm._e()], 2) : _c('div', [_vm._v("\n    * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.\n  ")])]), _vm._v(" "), _c('div', {
    class: (_vm.expandTable == true) ? 'hidden' : '',
    staticStyle: {
      "width": "500px",
      "padding": "44px 0px 10px 20px",
      "border-left": "1px solid #ccc",
      "position": "fixed",
      "top": "100px",
      "left": "calc(100vw - 535px)",
      "z-index": "1001",
      "float": "left"
    }
  }, [(_vm.editingDataRow != null) ? _c('div', [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "5px",
      "padding-bottom": "20px",
      "display": "inline-block",
      "float": "left"
    }
  }, [(_vm.editingDataRow.val.id != null) ? _c('span', [_c('b', [_vm._v("РЕДАКТИРОВАНИЕ :")])]) : _c('span', [_c('b', [_vm._v("НОВЫЙ ФАЙЛ :")])])]), _vm._v(" "), _c('div', {
    staticClass: "editingdatarow-image",
    style: ({
      'background-image': 'url(' + _vm.appSettings.server.host + _vm.appSettings.server.fileEntityGetFile + _vm.editingDataRow.val.id + ')'
    }),
    attrs: {
      "id": "editingdatarowimage"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "5px 0 15px 0",
      "text-align": "center",
      "clear": "left"
    }
  }, [_c('input', {
    ref: "editingDataRowFileRef",
    staticClass: "input_file_hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadingFileOnChange()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "padding": "5px 15px 5px 15px",
      "font-size": "15px",
      "color": "#fff",
      "background": "#aaa",
      "border": "solid 1px #a0a0a0",
      "border-radius": "5px 5px 5px 5px"
    },
    on: {
      "click": function($event) {
        _vm.$refs.editingDataRowFileRef.click()
      }
    }
  }, [_vm._v("Загрузить файл")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "110px",
      "padding-top": "3px",
      "padding-bottom": "5px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Имя")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "5px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 110px)"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.editingDataRow.val.name),
      callback: function($$v) {
        _vm.editingDataRow.val.name = $$v
      },
      expression: "editingDataRow.val.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "110px",
      "padding-top": "3px",
      "padding-bottom": "5px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Тип")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "28px",
      "padding": "5px 0 5px 0",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 110px)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editingDataRow.val.extension) + "\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "110px",
      "padding-top": "3px",
      "padding-bottom": "5px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Ссылка")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "28px",
      "padding": "5px 0 5px 0",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 110px)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.appSettings.server.host + _vm.appSettings.server.fileEntityGetFile + _vm.editingDataRow.val.id) + "\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "110px",
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "float": "left"
    }
  }, [_c('span', [_vm._v("Идентификатор")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "3px",
      "padding-bottom": "10px",
      "display": "inline-block",
      "clear": "left",
      "width": "calc(100% - 110px)"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.editingDataRow.val.id) + " \n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "35px 0px 5px 0px"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.saveEditingDataRowOnClick
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancelEditingDataRowOnClick
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('Button', {
    class: _vm.editingDataRow.val.id == null ? 'hidden' : '',
    staticStyle: {
      "float": "right",
      "border-radius": "3px",
      "margin-bottom": "10px",
      "padding-top": "5px",
      "color": "#d7d7d7"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.deleteEditingDataRowOnClick
    }
  }, [_c('Icon', {
    attrs: {
      "type": "trash-b",
      "size": "18"
    }
  })], 1)], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0197ae84","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CMSX/Media.vue
// module id = 362
// module chunks = 0